if (!customElements.get('spp-account-menu')) {
  customElements.define(
    'spp-account-menu',
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();

        const options = { signal: this.controller.signal };

        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        this.panel = this.querySelector('.spp-account__panel');

        if (!this.details || !this.trigger || !this.panel) return;

        const hoverAvailable = window.matchMedia(
          '(hover: hover) and (pointer: fine)'
        );

        this.addEventListener('pointerenter', (event) => {
          if (
  this.closest('.header__mobile') ||
  event.pointerType === 'touch' ||
  !hoverAvailable.matches
) return;
          this.details.open = true;
          this.positionPanel();
        }, options);

        this.addEventListener('pointerleave', (event) => {
          if (
  this.closest('.header__mobile') ||
  event.pointerType === 'touch' ||
  !hoverAvailable.matches
) return;

          if (!this.panel.contains(document.activeElement)) {
            this.details.open = false;
          }
        }, options);

        this.details.addEventListener('toggle', () => {
          if (this.details.open) this.positionPanel();
        }, options);

        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) {
            this.details.open = false;
          }
        }, options);

        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) {
            this.details.open = false;
          }
        }, options);

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            this.details.open = false;
            this.trigger.focus();
          }
        }, options);

        window.addEventListener('resize', () => {
          if (this.details.open) this.positionPanel();
        }, options);
      }

      positionPanel() {
  const anchor = this.details.getBoundingClientRect();
  const header = this.closest('.theme__header');
  const headerBounds = header?.getBoundingClientRect();
  const viewportWidth = document.documentElement.clientWidth;

  const top = headerBounds
    ? Math.max(anchor.height, headerBounds.bottom - anchor.top - 1)
    : anchor.height;

  const rightEdge = headerBounds
    ? Math.min(headerBounds.right, viewportWidth - 16)
    : anchor.right;

  this.panel.style.setProperty(
    '--account-panel-top',
    `${top}px`
  );

  this.panel.style.setProperty(
    '--account-panel-right',
    `${anchor.right - rightEdge}px`
  );

  this.panel.style.setProperty(
    '--account-panel-bridge',
    `${Math.max(10, top - anchor.height + 2)}px`
  );

  this.panel.style.setProperty('--account-panel-shift', '0px');

  const bounds = this.panel.getBoundingClientRect();
  let shift = 0;

  if (bounds.left < 16) {
    shift = 16 - bounds.left;
  } else if (bounds.right > viewportWidth - 16) {
    shift = viewportWidth - 16 - bounds.right;
  }

  this.panel.style.setProperty(
    '--account-panel-shift',
    `${shift}px`
  );
}

      disconnectedCallback() {
        this.controller?.abort();
      }
    }
  );
}